export const getEmojiByCode = (e) => {
    let sym = e.unified?.split("-");
    let codesArray = [];
    sym?.forEach((el) => codesArray.push("0x" + el));
    let emoji = String.fromCodePoint(...codesArray);
    return emoji;
}